import { render } from "./EditLogisticsServiceProvider.vue?vue&type=template&id=f6453352&scoped=true&ts=true"
import script from "./EditLogisticsServiceProvider.vue?vue&type=script&lang=ts"
export * from "./EditLogisticsServiceProvider.vue?vue&type=script&lang=ts"

import "./EditLogisticsServiceProvider.vue?vue&type=style&index=0&id=f6453352&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6453352"]])

export default __exports__